<template>

    <form ref="certificacoesregrasisencao-form-log"  novalidate>

        <div class="row">


            <div class="table-responsive standard-table header-cinza">
                <table>
                    <thead>
                        <tr>
                            <th>Data Hora<i></i></th>
                            <th style="text-align:center">COLABORADOR</th>
                            <th style="text-align:center">AÇÃO</th>                           
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="item in result.items" class="animated fadeIn">
                            <td>{{ item.dataHora}}</td>
                            <td>{{ item.colaborador.apelido}}</td>
                            <td>{{ item.descricaoAcaoRealizada}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>    
    </form>

</template>
<script>

    import base from '@/common/base.js'
    import { Api } from '@/common/api'

    export default {
        name: "certificacoespoliticapreco-log",
        mixins: [base],
        props: { id: Number },
        data() {
            return {
                resources: {
                    filter: 'certificacoeslog',
                    items: [],
                },              
                model: {},
                filter: {
                    pageSize: 50,
                    pageIndex: 1,
                    isPagination: true,
                },
                result: {
                    total: 0,
                    items: []
                }
            }
        },

        methods: {        

            onBack: function () {
                this.$emit('on-back')
            }
        },

        mounted() {        
            new Api(this.resources.filter).get({ auxiliarId: this.id, attributeBehavior: 'politicapreco' }).then(data => {
                if (data.data) this.model = data.data;
                this.result.items = data.dataList;
            }, err => {
                this.defaultErrorResult(err);
            })
        }
    };
</script>